import {
  BookOutlined,
  CheckCircleFilled,
  CheckCircleTwoTone,
  EditFilled,
  EyeInvisibleOutlined,
  LockFilled,
  MessageOutlined,
  SafetyCertificateFilled,
  UnlockOutlined,
} from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import React from "react";
import { StackedBadge } from "~/components/badges/BadgeLevels.jsx";
import { getBadgeConfig, showHighestBadgePerLevel } from "~/components/badges/BadgeConfig.js";
import { FlightMotorTime } from "~/components/form/FlightMotorTime.jsx";
import { LandingIcon } from "~/components/icon/icon.jsx";
import { $t } from "~/i18n.js";
import { colors } from "~/theme/colors.js";

export const FlightTags = ({
  flight,
  pilot = {},
  showNotitie = false,
  hidePrive = false,
  hideStatus = false,
  hideBeschrijving = false,
  hideTags = false,
}) => {
  const category = flight?.category?.trim() || "";
  return (
    <div className="row" style={{ gap: 4, alignItems: "center" }}>
      {!hideStatus && !flight.is_prive && flight.is_locked && (
        <LockFilled style={{ color: "black", marginRight: 2 }} />
      )}
      {!hideStatus && !flight.is_prive && !flight.is_locked && (
        <UnlockOutlined style={{ color: "black", marginRight: 2 }} />
      )}

      {!hidePrive && flight.is_prive && (
        <Tooltip
          placement="top"
          title={$t("Vlucht kan gewijzigd worden door vlieger")}
        >
          <EditFilled style={{ color: "black", marginRight: 2 }} />
        </Tooltip>
      )}

      {!flight.is_prive && !flight.igc_visible && (
        <Tooltip placement="top" title={$t("IGC niet zichtbaar")}>
          <EyeInvisibleOutlined
            style={{ color: "rgba(0, 0, 0, 0.25)", marginLeft: 6 }}
          />
        </Tooltip>
      )}

      {/* TODO: BADGE REMOVEL has_badges */}
      {/* {!hideTags && flight.badges?.length > 0 && (() => {
        const config = getBadgeConfig();
        const badges = showHighestBadgePerLevel(flight.badges);
        return badges.map((badge, idx) => (
          <StackedBadge
            key={idx}
            icon={config[badge.name]?.icon}
            label={badge.name}
            count={badge.level}
            size={18}
            earned
          />
        ));
      })()} */}

      {category && <Tag color="blue">{category}</Tag>}

      {flight.authorised && (
        <Tooltip
          placement="top"
          title={$t("Vlucht is geauthoriseerd door ${instructor}", {
            instructor: flight.authorised.name,
          })}
        >
          <SafetyCertificateFilled style={{ color: colors.groen_dark }} />
        </Tooltip>
      )}

      {flight.signed ? (
        <Tooltip
          placement="top"
          title={$t("Vlucht is afgetekend door ${instructor}", {
            instructor: flight.signed.name,
          })}
        >
          <CheckCircleFilled style={{ color: colors.groen_dark }} />
        </Tooltip>
      ) : (
        flight.authorised && (
          <Tooltip
            placement="top"
            title={$t("Vlucht is geauthoriseerd maar nog niet afgetekend")}
          >
            <CheckCircleTwoTone twoToneColor={colors.red} />
          </Tooltip>
        )
      )}

      {flight.is_fis && (
        <Tooltip placement="top" title={$t("Instructievlucht")}>
          <Tag color="lime">FI(s)</Tag>
        </Tooltip>
      )}
      {flight.is_training && (
        <Tooltip
          placement="top"
          title={$t("EASA trainingsvlucht met instructeur")}
        >
          <Tag color="geekblue">{$t("training")}</Tag>
        </Tooltip>
      )}
      {flight.is_examen && (
        <Tooltip placement="top" title={$t("Examen vlucht")}>
          <Tag color="geekblue">{$t("examen")}</Tag>
        </Tooltip>
      )}
      {flight.is_profcheck && (
        <Tooltip placement="top" title={$t("EASA prof-check")}>
          <Tag color="geekblue">{$t("prof")}</Tag>
        </Tooltip>
      )}

      {pilot &&
        (flight.is_training || flight.is_examen || flight.is_profcheck) &&
        flight.gezagvoerder_id === pilot.id && (
          <Tooltip
            placement="top"
            title={$t(
              "EASA trainingsvlucht, Examen of Profcheck als instructeur.",
            )}
          >
            <Tag color="geekblue">{$t("afgenomen")}</Tag>
          </Tooltip>
        )}

      {flight.is_overland && (
        <Tooltip placement="top" title={$t("Overland vlucht")}>
          <Tag color="green">
            {flight.afstand > 0 ? flight.afstand + "km" : $t("Ovl")}
          </Tag>
        </Tooltip>
      )}
      {flight.vertrek_vliegveld &&
        flight.aankomst_vliegveld &&
        flight.vertrek_vliegveld !== flight.aankomst_vliegveld && (
          <Tag color="green">
            <LandingIcon size={12} />
            <span style={{ marginLeft: 4 }}>{flight.aankomst_vliegveld}</span>
          </Tag>
        )}

      {flight.is_deleted && <Tag color="red">{$t("verwijderd")}</Tag>}

      {flight.club_tag && (
        <Tooltip
          placement="top"
          title={$t("Vlucht is geimporteerd vanuit een andere club")}
        >
          <Tag color="cyan">{flight.club_tag}</Tag>
        </Tooltip>
      )}

      {!hideBeschrijving && (
        <>
          {showNotitie
            ? (flight.notitie || flight.bijzonderheden) && (
                <Tooltip
                  placement="left"
                  title={`${flight.bijzonderheden} ${flight.notitie}`}
                >
                  <MessageOutlined style={{ margin: "0 2px" }} />
                </Tooltip>
              )
            : flight.bijzonderheden && (
                <Tooltip placement="left" title={flight.bijzonderheden}>
                  <MessageOutlined style={{ margin: "0 2px" }} />
                </Tooltip>
              )}
        </>
      )}

      {flight.voucher && (
        <Tag color="green">
          <BookOutlined />
        </Tag>
      )}
    </div>
  );
};

export const FlightTagColumn = () => ({
  render: (_, flight) => (
    <div>
      <FlightTags flight={flight} />
      {flight.motor_minutes > 0 && (
        <Tag>
          <FlightMotorTime motorMinutes={flight.motor_minutes} />
        </Tag>
      )}
    </div>
  ),
  filters: [
    { text: $t("training"), value: "training" }, //
    { text: $t("examen"), value: "examen" }, //
    { text: $t("overland"), value: "overland" }, //
  ],
  onFilter: (value, record) => {
    if (value === "training") return record.is_training;
    if (value === "examen") return record.is_examen || record.is_profcheck;
    if (value === "overland") return record.is_overland;
    return false;
  },
});
